var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-right",attrs:{"id":"copy-right"}},[_vm._v("Copyright © 2020 Real-Shopper All Rights Reserved.")])}
var staticRenderFns = []

export { render, staticRenderFns }